import React from 'react';
import { Box, Typography } from '@mui/material';
import { PageTitle } from '../../layouts/components/PageTitle';
import MainLayout from '../../layouts/Main';

export default function NotFound() {
	return (
		<MainLayout>
			<Box mb={5}>
				<PageTitle title="Oops! Page not found" />
				<Box>
					<Typography>
						The page you're looking for is not found. Please make sure the URL is
						correct or try to use our search tool.
					</Typography>
				</Box>
			</Box>
		</MainLayout>
	);
}
